import { autoserialize } from 'cerialize';

export class StoreMeta {
  @autoserialize isStoreReady: boolean;
  @autoserialize capacity: boolean;

  constructor(payload?: IStoreMeta | null) {
    this.isStoreReady = !!payload?.isStoreReady;
    this.capacity = !!payload?.capacity;
  }
}

export interface IStoreMeta {
  isStoreReady?: boolean;
  capacity?: boolean;
}
